import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { Box, Modal, Typography } from '@mui/material'
import { TOOLKIT_SUMMARISE_DOCUMENTS_SELECT_PAGES } from '@/config'

const SelectSummaryType = (props: any) => {
  const { t } = useTranslation()
  const history = useHistory()
  const [documents, setDocuments] = useState(null)

  useEffect(() => {
    if (props.documents && props.documents.length === 0) {
      return
    }
    setDocuments(props.documents)
  }, [props.documents])

  const onSetSummaryType = (summaryType: string) => {
    props.onSetSummaryType(summaryType)
  }

  return (
    <Modal open={props.show} onClose={props.onHide} sx={{ outline: 0 }}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: '683px',
          maxWidth: '95vw',
          maxHeight: '80vh',
          bgcolor: 'background.paper',
          transform: 'translate(-50%, -50%)',
          borderRadius: '8px',
          overflow: 'auto',
          p: 3,
        }}
      >
        <Box className="form-group">
          <Typography component="label" sx={{ fontWeight: 600 }}>
            {t('Summarize Document(s)')}
          </Typography>
          <Typography className="clr-grey-txt7" sx={{ fontWeight: 600 }}>
            {t('How should the documents be summarized?')}
          </Typography>
          <div className="row px-2 justify-content-center">
            <div
              className="col-6 px-2"
              onClick={() => {
                if (props.uploadDoc) {
                  onSetSummaryType('single')
                } else {
                  history.push(
                    `${TOOLKIT_SUMMARISE_DOCUMENTS_SELECT_PAGES}?documents=${documents.join(
                      ',',
                    )}&group=${props.groups}&summary-type=single${
                      props.selectFromKnowledgeBase ? `&through=documents` : ''
                    }`,
                  )
                }
              }}
            >
              <div
                className={classNames({
                  'py-4 px-3 border-grey d-flex align-items-center radius-8 h-100 text-center':
                    true,
                })}
              >
                <Box>
                  <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                    {t('Merge Document(s)')}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{ color: 'text.secondary' }}
                  >
                    {t(
                      'Consolidate and summarize uploaded documents into a single file.',
                    )}
                  </Typography>
                </Box>
              </div>
            </div>
            <div
              className="col-6 px-2"
              onClick={() => {
                if (props.uploadDoc) {
                  onSetSummaryType('individual')
                } else {
                  history.push(
                    `${TOOLKIT_SUMMARISE_DOCUMENTS_SELECT_PAGES}?documents=${documents.join(
                      ',',
                    )}&group=${props.groups}&summary-type=individual${
                      props.selectFromKnowledgeBase ? `&through=documents` : ''
                    }`,
                  )
                }
              }}
            >
              <div
                className={classNames({
                  'py-4 px-3 border-grey radius-8 h-100 d-flex align-items-center text-center':
                    true,
                })}
              >
                <Box>
                  <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                    {t('Summarize Document(s) individually')}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{ color: 'text.secondary' }}
                  >
                    {t(
                      'Each uploaded file will be summarized individually. Recommended for unstructured documents (e.g., transcripts) and PowerPoint slides.',
                    )}
                  </Typography>
                </Box>
              </div>
            </div>
          </div>
        </Box>
      </Box>
    </Modal>
  )
}

export default SelectSummaryType
